export default "__VITE_ASSET__DwcEzr0G__"